var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGraySendIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.934863 2.49679L1.07699 2.44882L0.934863 2.4968L3.74603 10.8253C3.74503 10.8384 3.74452 10.8516 3.74452 10.8649C3.74452 10.8796 3.74515 10.8942 3.74637 10.9086L0.91494 19.5122C0.568912 20.5637 1.66411 21.5103 2.65417 21.0152L2.59396 20.8948L2.65417 21.0152L20.4619 12.1095C21.3794 11.6506 21.3794 10.341 20.4619 9.88213L2.67111 0.984861C1.67697 0.48769 0.579401 1.44367 0.934863 2.49679ZM1.89323 19.8343L1.77691 19.796L1.89324 19.8343L4.67556 11.3799H11.4587C11.7431 11.3799 11.9736 11.1493 11.9736 10.8649C11.9736 10.5804 11.7431 10.3498 11.4587 10.3498H4.67257L1.91069 2.16733C1.91069 2.16733 1.91069 2.16733 1.91069 2.16732C1.84927 1.98534 2.0389 1.82038 2.21048 1.90618L20.0012 10.8035C20.1597 10.8827 20.1597 11.1089 20.0012 11.1882L2.19354 20.0939C2.02268 20.1793 1.83344 20.016 1.89323 19.8343Z",
    fill: "#979797",
    stroke: "#979797",
    strokeWidth: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraySendIcon);
export default __webpack_public_path__ + "static/media/graySendIcon.acc18aa7487a364c51317318f4f4fe23.svg";
export { ForwardRef as ReactComponent };